import React from 'react';
import styled from 'styled-components';
import useTranslation from '@src/hooks/useTranslation';

import useEvent from '@src/hooks/useEvent';
import { getEventTimeRange } from '@src/utils/event';
import { getTimeRange } from '@src/utils/time';
import { TAB_OFFLINE_EVENT_INFORMATION } from '@src/const/event';

import { BulletIcon } from '@src/components/common/icon';
import Header from '@src/components/common/header';
import BulletListItem from '@src/components/common/bulletListItem';
import { BlockWrapper } from '@src/components/common/commonStyle';

const InformationWrapper = styled(BlockWrapper)`
	padding-bottom: 40px;
	border-left: 4px solid ${props => props.theme.colors.primary};
	border-right: 4px solid ${props => props.theme.colors.primary};
	background: ${props => props.theme.colors.block};

	@media ${props => props.theme.device.smTablet} {
		padding-bottom: 32px;
	}

	@media ${props => props.theme.device.mobile} {
		padding-bottom: 32px;
	}
`;

const Content = styled.div`
	& > *:not(:first-child) {
		margin-top: 32px;
	}
`;

const SlotTimeInfoWrapper = styled.div`
	& > *:not(:first-child) {
		margin-top: 8px;
	}
`;

const Information = (): JSX.Element => {
	const { t } = useTranslation();
	const { event: { host_by, location }, sortedEventSlots } = useEvent();
	const eventTimeRange = getEventTimeRange({ sortedEventSlots, t });
	const slotsInfoList = sortedEventSlots.map(
		slot => `${slot.name} ${getTimeRange({ startTime: slot.start_at, endTime: slot.end_at, t })}`,
	);

	return (
		<InformationWrapper id={TAB_OFFLINE_EVENT_INFORMATION}>
			<Header text={t(`event:${TAB_OFFLINE_EVENT_INFORMATION}`)} />
			<Content>
				<BulletListItem
					title={t('event:host_by')}
					content={host_by}
					BulletIcon={BulletIcon}
				/>
				<BulletListItem
					title={t('event:slots_info')}
					content={(
						<SlotTimeInfoWrapper>
							{slotsInfoList.map(eventTime => (
								<div key={eventTime} className="slot-time-info-time-item">
									{eventTime}
								</div>
							))}
						</SlotTimeInfoWrapper>
					)}
					BulletIcon={BulletIcon}
				/>
				<BulletListItem
					title={t('event:events_duration')}
					content={eventTimeRange}
					BulletIcon={BulletIcon}
				/>
				<BulletListItem
					title={t('event:events_location')}
					content={location}
					BulletIcon={BulletIcon}
				/>
			</Content>
		</InformationWrapper>
	);
};

export default Information;
